import React from 'react';
import classes from './CategoryTabWrapper.module.css';

import CategoryTab from '../CategoryTab/CategoryTab';

const CategoryTabWrapper = (props) => {
    //console.log(props);
    return (
        <div className={classes.CategoryTabWrapper}>
            {props.category.map(c => 
                <CategoryTab key={c.id} category={c} />    
            )}
        </div>
    )
}

export default CategoryTabWrapper
